module.exports = __webpack_public_path__ + "static/media/adapted-white.9cff7af4.svg";